<template>
    <div>
        <vue-headful
            title="Tid.nu - Hitta rätt tid för mötet"
            description="möten"
            keywords="möten schedule"
        />
        <v-row>

                <v-container :loading="store.state.loading">
                    <v-stepper v-model="store.state.e1">
                        <v-stepper-header>
                            <v-stepper-step
                                :complete="store.state.e1 > 1"
                                step="1"
                                >Mötesdetaljer</v-stepper-step
                            >

                            <v-divider></v-divider>

                            <v-stepper-step
                                :complete="store.state.e1 > 2"
                                step="2"
                                >Lägg till förslag på datum och tid </v-stepper-step
                            >

                            <v-divider></v-divider>

                            <v-stepper-step step="3"
                                >Dela med deltagare</v-stepper-step
                            >
                        </v-stepper-header>

                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <step1 />
                            </v-stepper-content>

                            <v-stepper-content step="2">
                                <step2 />
                            </v-stepper-content>

                            <v-stepper-content step="3">
                                <step3 />
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-container>
        </v-row>
    </div>
</template>

<script>
import step1 from "./createmeeting/step1";
import step2 from "./createmeeting/step2";
import step3 from "./createmeeting/step3";
import store from "../../store";
export default {
    name: "createmeeting",
//     metaInfo: {
//     title: 'Tid.nu',
//     titleTemplate: '%s | Välkommen till Tid.nu!',
//     meta: [
//       { charset: 'utf-8' },
//       { name: 'description', content: 'möten' },
//       { name: 'viewport', content: 'width=device-width, initial-scale=1' }
//     ]
//   },
    components: {
        step1,
        step2,
        step3
    },
    data: () => ({
        e1: 1,
        isLoggedIn: null,
        loading: false,
        store: store
    }),
    created: function() {
        this.isLoggedIn = this.store.state.isLoggedIn;
        this.store.state.e1 = 1;
        this.store.state.schedule = {
            date: [],
            title: "",
            description: "",
            location: "",
            theme: 0,
            ifNeeded: false,
            deadlineReply: false,
            deadlineDate: null,
            oneAns: false,
            contactInfo: false,
            hidSchedule: false,
            adminOnly: false,
            time: []
        };
    }
};
</script>

<style></style>
